import React from 'react';
import { StyleSheet, Text, TextStyle, View, ViewStyle } from 'react-native';

export type WarningItem = {
	show: boolean;
	text: string;
};

type TournamentWarningTextProps = {
	warnings: WarningItem[];
	textStyle: TextStyle | TextStyle[];
	containerStyle?: ViewStyle | ViewStyle[];
	maxLines?: number;
};

const TournamentWarningText: React.FC<TournamentWarningTextProps> = ({
	warnings,
	textStyle,
	containerStyle,
	maxLines = 2,
}) => {
	const visible = warnings.filter(w => w.show);

	if (visible.length === 0) return null;

	return (
		<View style={[styles.container, containerStyle]}>
			{visible.map((w, i) => (
				<Text
					key={i}
					numberOfLines={maxLines}
					adjustsFontSizeToFit
					minimumFontScale={0.72}
					style={textStyle}
				>
					{w.text}
				</Text>
			))}
		</View>
	);
};

const styles = StyleSheet.create({
	container: {
		minHeight: 28,
		justifyContent: 'flex-start',
	},
});

export default TournamentWarningText;
